<template>
  <section class="docs">
    <div class="docs_sidebar">
      <SubSidebar :routes="routes" title="API" />
    </div>
    <div class="docs_router">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import SubSidebar from '@/components/components/SubSidebar.vue';

export default {
  components: {
    SubSidebar,
  },
  data() {
    return {
      routes: [
        {
          name: 'Authentication',
          linkName: 'DocsAPIAuth',
        },
        {
          name: 'Salons',
          linkName: 'DocsAPISalons',
        },
        {
          name: 'Appointments',
          linkName: 'DocsAPIAppointments',
        },
        {
          name: 'Tickets',
          linkName: 'DocsAPITickets',
        },
        {
          name: 'Staff',
          linkName: 'DocsAPIStaff',
        },
        {
          name: 'Clients',
          linkName: 'DocsAPIClients',
        },
        {
          name: 'Services',
          linkName: 'DocsAPIServices',
        },
        {
          name: 'Gift Cards',
          linkName: 'DocsAPIGiftcards',
        },
        {
          name: 'Settings',
          linkName: 'DocsAPISettings',
        },
        {
          name: 'Dejavoo',
          linkName: 'DocsAPIDejavoo',
        },
        {
          name: 'Guide - Creating a salon',
          linkName: 'DocsAPIGuideCreatingSalon',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.docs {
  display: flex;
  height: 100%;
  width: 100%;

  &_router {
    overflow-y: auto;
    flex-grow: 1;
    padding: 32px;
    display: flex;
    justify-content: center;
  }
}

// Tablet
@media (max-width: 900px) {
  .docs {
    &_router {
      padding: 16px;
      justify-content: flex-start;
    }
  }
}
</style>
